import React, { useState, useEffect, useCallback } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import PageHeader from '../../components/PageHeader';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';
import Modal from '../../components/modal';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPencilAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import useSubmitLock from '../../utils/useSubmitLock';
import { localToday } from '../../utils/dateUtils';

const emptyForm = () => ({ date: localToday(), remedy: '', dosage: '', frequency: '', observation: '', active: true });

const Medicacao = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { listInternals, createDosage, listDosageInternal, updateDosage } = useInternals();
  const { listRemedies, createRemedy } = useAuxiliaries();
  const { buildUnitReadParams } = useUsers();
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [internalDetails, setInternalDetails] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);
  const [dosages, setDosages] = useState([]);
  const [remedies, setRemedies] = useState([]);
  const [formData, setFormData] = useState(emptyForm);
  const [editData, setEditData] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddRemedyModalOpen, setIsAddRemedyModalOpen] = useState(false);
  const [newRemedyName, setNewRemedyName] = useState('');

  useEffect(() => {
    listRemedies().then((res) => setRemedies(res?.results || res || [])).catch(() => {});
  }, [listRemedies]);

  const loadDosages = useCallback(async (id) => {
    if (!id) return;
    const response = await listDosageInternal(id);
    setDosages(response?.results || response || []);
  }, [listDosageInternal]);

  const handleInternalSelect = useCallback(async (internal) => {
    if (!internal?.id) return;
    setInternalDetails(internal);
    await loadDosages(internal.id);
  }, [loadDosages]);

  useEffect(() => {
    if (internalId) {
      (async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internal = response?.results?.[0];
          if (internal) handleInternalSelect(internal);
        } catch (err) {
          console.error('Erro ao carregar interno:', err);
        }
      })();
    }
  }, [internalId, listInternals, buildUnitReadParams, handleInternalSelect]);

  const handleAddRemedy = async (e) => {
    e.preventDefault();
    if (!newRemedyName.trim()) { toast.error('Informe o nome do medicamento.'); return; }
    const created = await createRemedy(newRemedyName.trim());
    if (created) {
      const res = await listRemedies();
      setRemedies(res?.results || res || []);
      setFormData((prev) => ({ ...prev, remedy: created.id }));
      setNewRemedyName('');
      setIsAddRemedyModalOpen(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!internalDetails?.id) { toast.error('Selecione um interno.'); return; }
      if (!formData.remedy || !formData.dosage || !formData.frequency) {
        toast.error('Preencha medicamento, dosagem e frequência.');
        return;
      }
      await createDosage({ ...formData, internal: internalDetails.id });
      setFormData(emptyForm());
      loadDosages(internalDetails.id);
    });
  };

  const handleEditOpen = (item) => {
    const dateVal = item.date ? item.date.split('T')[0] : localToday();
    setEditData({
      id: item.id,
      date: dateVal,
      remedy: item.remedy ?? '',
      dosage: item.dosage || '',
      frequency: item.frequency || '',
      observation: item.observation || '',
      active: item.active !== false,
    });
    setIsEditModalOpen(true);
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      if (!editData.remedy || !editData.dosage || !editData.frequency) {
        toast.error('Preencha medicamento, dosagem e frequência.');
        return;
      }
      const { id, ...rest } = editData;
      await updateDosage(id, rest);
      setIsEditModalOpen(false);
      loadDosages(internalDetails.id);
    });
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container social-container admission-page">
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
        />

        <PageHeader
          title="Medicação"
          subtitle="Registro de medicamentos e dosagens do interno."
          internalDetails={internalDetails}
        />

        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
          <>
            <div className="social-tabs">
              <button className="social-tab-button active">Medicação</button>
            </div>

            <div className="social-tab-content">
              <div className="vacina-container">
                <form onSubmit={handleSubmit} className="evolucao-container">
                  <div className="social-form-group-duplo">
                    <div className="social-form-group">
                      <label>Data</label>
                      <input
                        type="date"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="social-form-group">
                      <label>Medicamento</label>
                      <div className="med-remedy-wrapper">
                        <select name="remedy" value={formData.remedy} onChange={handleChange}>
                          <option value="">Selecione</option>
                          {remedies.map((r) => (
                            <option key={r.id} value={r.id}>{r.name}</option>
                          ))}
                        </select>
                        <button
                          type="button"
                          className="med-add-remedy-btn"
                          title="Cadastrar novo medicamento"
                          onClick={() => setIsAddRemedyModalOpen(true)}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </div>
                    </div>
                    <div className="social-form-group">
                      <label>Dosagem</label>
                      <input
                        type="text"
                        name="dosage"
                        value={formData.dosage}
                        onChange={handleChange}
                        placeholder="Ex: 500mg"
                      />
                    </div>
                    <div className="social-form-group">
                      <label>Frequência</label>
                      <input
                        type="text"
                        name="frequency"
                        value={formData.frequency}
                        onChange={handleChange}
                        placeholder="Ex: 8/8h"
                      />
                    </div>
                  </div>
                  <div className="social-form-group">
                    <label>Observação</label>
                    <textarea
                      name="observation"
                      rows="3"
                      value={formData.observation}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="social-form-group">
                    <button type="submit" className="social-submit-button" disabled={isSubmitting}>
                      {isSubmitting ? 'Salvando...' : 'Adicionar Medicação'}
                    </button>
                  </div>
                </form>

                <div className="timeline">
                  <h4>Histórico de medicações</h4>
                  <ul className="timeline-list">
                    {dosages.length > 0 ? (
                      dosages.map((item) => (
                        <li key={item.id} className="timeline-item">
                          <div className="timeline-date">
                            <FontAwesomeIcon icon={faClock} />{' '}
                            {item.date ? item.date.split('T')[0].split('-').reverse().join('/') : ''}
                            <button
                              type="button"
                              className="med-edit-btn"
                              onClick={() => handleEditOpen(item)}
                              title="Editar"
                            >
                              <FontAwesomeIcon icon={faPencilAlt} />
                            </button>
                          </div>
                          <div className="timeline-content">
                            <p><strong>Medicamento:</strong> {item.remedy_name || '-'}</p>
                            <p><strong>Dosagem:</strong> {item.dosage || '-'}</p>
                            <p><strong>Frequência:</strong> {item.frequency || '-'}</p>
                            <p><strong>Ativo:</strong> {item.active ? 'Sim' : 'Não'}</p>
                            {item.observation && <p><strong>Observação:</strong> {item.observation}</p>}
                          </div>
                        </li>
                      ))
                    ) : (
                      <p>Nenhuma medicação registrada.</p>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {isAddRemedyModalOpen && (
        <Modal
          title="Cadastrar Medicamento"
          isOpen={isAddRemedyModalOpen}
          closeModal={() => { setIsAddRemedyModalOpen(false); setNewRemedyName(''); }}
        >
          <form onSubmit={handleAddRemedy} className="unit-modal-form unit-modal-grid">
            <div className="unit-modal-field span-2">
              <label>Nome</label>
              <input
                type="text"
                value={newRemedyName}
                onChange={(e) => setNewRemedyName(e.target.value)}
                placeholder="Ex: Amoxicilina"
                autoFocus
              />
            </div>
            <div className="unit-modal-actions">
              <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </Modal>
      )}

      {isEditModalOpen && editData && (
        <Modal
          title="Editar Medicação"
          isOpen={isEditModalOpen}
          closeModal={() => setIsEditModalOpen(false)}
        >
          <form onSubmit={handleEditSubmit} className="unit-modal-form unit-modal-grid">
            <div className="unit-modal-field span-2">
              <label>Data</label>
              <input type="date" name="date" value={editData.date} onChange={handleEditChange} />
            </div>
            <div className="unit-modal-field span-2">
              <label>Medicamento</label>
              <select name="remedy" value={editData.remedy} onChange={handleEditChange}>
                <option value="">Selecione</option>
                {remedies.map((r) => (
                  <option key={r.id} value={r.id}>{r.name}</option>
                ))}
              </select>
            </div>
            <div className="unit-modal-field">
              <label>Dosagem</label>
              <input type="text" name="dosage" value={editData.dosage} onChange={handleEditChange} />
            </div>
            <div className="unit-modal-field">
              <label>Frequência</label>
              <input type="text" name="frequency" value={editData.frequency} onChange={handleEditChange} />
            </div>
            <div className="unit-modal-field span-2">
              <label>Observação</label>
              <textarea name="observation" rows="3" value={editData.observation} onChange={handleEditChange} />
            </div>
            <div className="unit-modal-field span-2">
              <label>
                <input type="checkbox" name="active" checked={editData.active} onChange={handleEditChange} />
                {' '}Ativo
              </label>
            </div>
            <div className="unit-modal-actions">
              <button type="submit" className="btnConfirmar" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
};

export default Medicacao;
